import DeferredCoverageAndDocuments from "./DeferredCoverageAndDocuments";
import PayoutCoverageAndDocuments from "./PayoutCoverageAndDocuments";

import { isPolicyPayoutAnnuity } from "js/utilities";

function CoverageAndDocuments(props) {
  const { policy, filteredDocuments, deathBenefitValue } = props;

  if (isPolicyPayoutAnnuity(policy)) {
    return (
      <PayoutCoverageAndDocuments
        policy={policy}
        filteredDocuments={filteredDocuments}
      />
    );
  }

  return (
    <DeferredCoverageAndDocuments
      policy={policy}
      filteredDocuments={filteredDocuments}
      deathBenefitValue={deathBenefitValue}
    />
  );
}

export default CoverageAndDocuments;
